import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Package, Users } from 'lucide-react';
import { goToCheckout } from '../constants/links';
export function Hero() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="relative bg-navy text-white pb-10" data-id="element-103">
      {/* Urgency Bar */}
      <div className="sticky top-0 z-50 bg-turquoise text-white text-xs font-bold py-2 px-4 text-center flex items-center justify-center gap-2" data-id="element-104">
        <span data-id="element-105">⏰ Precio de lanzamiento — cierra en:</span>
        <span className="font-mono bg-white/20 px-2 py-0.5 rounded" data-id="element-106">
          {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
          {formatTime(timeLeft.seconds)}
        </span>
      </div>

      <div className="max-w-md mx-auto px-4 pt-4 flex flex-col items-center text-center" data-id="element-107">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-navy-light border border-violet/30 text-violet px-3 py-1.5 rounded-full text-xs font-bold mb-3" data-id="element-108">
          <span data-id="element-109">🎵</span>
          <span data-id="element-110">Para Docentes de Música · Edición 2026</span>
        </div>

        {/* Title */}
        <h1 className="text-[28px] leading-[1.15] font-extrabold mb-2 text-white" data-id="element-111">
          Tus clases de Flauta Dulce{' '}
          <span className="text-turquoise" data-id="element-112">Resueltas</span>.
        </h1>

        {/* Mockup Image */}
        <motion.div className="w-full max-w-[260px] my-1 relative z-10" animate={{
        y: [-8, 8, -8]
      }} transition={{
        repeat: Infinity,
        duration: 6,
        ease: 'easeInOut'
      }} data-id="element-113">
          <img src="https://cdn.magicpatterns.com/uploads/iuoc4p7ru2w8VGcNsZZvfG/Untitled_design_(4).png" alt="Flauta Master Class Mockup" className="w-full h-auto drop-shadow-2xl" data-id="element-114" />
        </motion.div>

        {/* Subtitle */}
        <p className="text-[14px] leading-[1.5] text-gray-light mb-4 px-2" data-id="element-115">
          Más de 200 partituras organizadas por ocasión, para que nunca más
          armes un acto escolar o una clase de música desde cero.
        </p>

        {/* Buttons */}
        <div className="w-full flex flex-col gap-2.5 mb-4" data-id="element-116">
          <button onClick={() => goToCheckout('pro')} className="w-full h-[56px] bg-turquoise hover:bg-turquoise/90 text-white font-bold text-lg rounded-xl transition-colors flex items-center justify-center gap-2 shadow-lg shadow-turquoise/20" data-id="element-117">
            <span data-id="element-118">🎵</span> Quiero Flauta Master Class PRO
          </button>
          <button className="w-full h-[48px] bg-transparent border-2 border-violet text-violet font-bold text-base rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-119">
            Ver qué incluye ↓
          </button>
        </div>

        {/* Trust Bar */}
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-gray-light font-medium" data-id="element-120">
          <div className="flex items-center gap-1" data-id="element-121">
            <Star className="w-3.5 h-3.5 text-gold fill-gold" data-id="element-122" />
            <span data-id="element-123">4.9/5</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-124">
            <Users className="w-3.5 h-3.5" data-id="element-125" />
            <span data-id="element-126">+900 docentes</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-127">
            <Package className="w-3.5 h-3.5" data-id="element-128" />
            <span data-id="element-129">+200 partituras listas</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-130">
            <ShieldCheck className="w-3.5 h-3.5" data-id="element-131" />
            <span data-id="element-132">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}